(function () {
  'use strict';

  class SaIndustrialApplication extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-ia-item]'));
      if (!this.items.length) return;

      var self = this;
      this._handlers = this.items.map(function (el, i) {
        var onEnter = function () {
          self.setActive(i);
        };
        el.addEventListener('mouseenter', onEnter);
        el.addEventListener('focusin', onEnter);
        return { el: el, onEnter: onEnter };
      });

      if (window.Shopify && window.Shopify.designMode) {
        this._onSelect = function (e) {
          if (!self.contains(e.target)) return;
          var item = e.target.closest && e.target.closest('[data-ia-item]');
          var idx = self.items.indexOf(item);
          if (idx > -1) self.setActive(idx);
        };
        document.addEventListener('shopify:block:select', this._onSelect);
      }
    }

    disconnectedCallback() {
      if (this._handlers) {
        this._handlers.forEach(function (h) {
          h.el.removeEventListener('mouseenter', h.onEnter);
          h.el.removeEventListener('focusin', h.onEnter);
        });
        this._handlers = null;
      }
      if (this._onSelect) {
        document.removeEventListener('shopify:block:select', this._onSelect);
        this._onSelect = null;
      }
    }

    setActive(i) {
      this.items.forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === i);
      });
    }
  }

  if (!customElements.get('sa-industrial-application')) {
    customElements.define('sa-industrial-application', SaIndustrialApplication);
  }
})();
